<!-- Contacts model  -->
<div class="modal-header">
    <h5 class="modal-title">Modifier un site d'essais pilotes</h5>
    <button  type="button" class="close" aria-label="Close"  (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body p-3">
    <div class="text-left">
        <form>

            <div class="row mb-3">

                <div class="form-group col-md-6">
                    <label for="name">Nom</label>
                    <input [(ngModel)]="item.nom" name="code" type="text" class="form-control" id="name" >
    
                </div> 
                <div class="form-group col-md-6">
                    <label for="name">Description</label>
                    <input [(ngModel)]="item.description" name="libelle" type="text" class="form-control" id="name" >
    
                </div> &nbsp;
            </div><br>
           

            <div class="row mb-3">
                <div class="form-group col-md-6">
                    <label for="email">Longitude </label>
                    <input [(ngModel)]="item.longitude" type="number" name="poids_action" class="form-control" id="arrondissement_id">
    
                </div>
    
                <div class="form-group  col-md-6">
                    <label for="name">Latitude</label>

                    <input [(ngModel)]="item.latitude" name="responsable_action" type="number" class="form-control" id="name">

                </div>
            </div><br>
           
            <div class="row mb-3">
                <div class="form-group col-md-6">
                  <label for="departement">Département</label>
                  <select name="departement" id="departement" class="form-select" [(ngModel)]="selectedDepartementId" (change)="onDepartementChange($event.target.value)">
                    <option value="">Sélectionner un département</option>
                    <option *ngFor="let item of departement" [value]="item.id">{{ item.libelle }}</option>
                  </select>
                </div>
              
                <div class="form-group col-md-6">
                  <label for="commune">Commune</label>
                  <select name="commune" id="commune" class="form-select" [(ngModel)]="selectedCommuneId" (change)="oncommuneChange($event.target.value)">
                    <option value="">Sélectionner une commune</option>
                    <option *ngFor="let item of commune" [value]="item.id">{{ item.libelle }}</option>
                  </select>
                </div>
              </div>


            <div class="row mb-3">
                <div class="form-group col-md-6">
                    <label for="name">Arrondissement</label>
                    <select name="programme_id" id="programme_id" class="form-select"  [(ngModel)]="item.arrondissement_id" >
    
                        <option> Selectionner un arrondissement</option>
                        <option *ngFor="let item of arrondissement" [value]="item.id"> {{item.libelle}}</option>
                    </select>
                </div> 

                <div class="form-group  col-md-6">
                    <label for="name">Photo</label>

                    <input (change)="onFileSelected($event)"  name="photo" type="file" class="form-control" id="name">

                </div>

                <div *ngIf="item" class="mt-3">
                    <img [src]="photoPreview" alt="Aperçu de la photo" style="width: 100%; height: 300px;">
                </div>
            </div>

            


            <div class="text-end">
                <button  (click)="close()" type="button" class="btn btn-info ms-1"> <i class="pi pi-times" style="color: white"></i>  Annuler </button> &nbsp;

                <button (click)="EditCentre()" type="submit" class="btn btn-success"> <i class="pi pi-save" style="color: white"></i> Enregistrer </button>
            </div>
        </form>
    </div>
</div>

<p-toast />
